import { SECTORS, sectorCentroid } from "../lib/geometry";
import type { Factor } from "../types/driehoek-data";

const SECTOR_LABELS: Record<Factor, string> = {
  omgeving: "omgeving",
  gezin: "gezin",
  kind: "kind",
};

function polygonPoints(poly: [number, number][]): string {
  return poly.map(([x, y]) => `${x},${y}`).join(" ");
}

interface LabelDebugOverlayProps {
  onLoadFixture?: () => void;
}

export function LabelDebugOverlay({ onLoadFixture }: LabelDebugOverlayProps) {
  return (
    <>
      <svg
        className="cd-debug-svg"
        viewBox="0 0 400 400"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden
      >
        {(Object.keys(SECTORS) as Factor[]).map((factor) => {
          const [cx, cy] = sectorCentroid(factor);
          return (
            <g key={factor} className={`cd-debug-sector-${factor}`}>
              <polygon
                points={polygonPoints(SECTORS[factor])}
                strokeWidth={2}
                strokeDasharray="6 4"
              />
              <circle className="cd-debug-marker" cx={cx} cy={cy} r={5} opacity={0.8} />
              <text
                x={cx}
                y={cy - 10}
                className="cd-debug-label"
                textAnchor="middle"
              >
                {SECTOR_LABELS[factor]}
              </text>
            </g>
          );
        })}
        <polygon
          points="200,126 112,279 288,279"
          fill="rgba(220, 38, 38, 0.08)"
          stroke="#dc2626"
          strokeWidth={1.5}
          strokeDasharray="4 3"
        />
      </svg>
      <aside className="cd-debug-panel" aria-label="Debug-paneel">
        <p className="cd-debug-panel__title">Debug (Ctrl+D)</p>
        <p className="cd-debug-panel__text">
          Gestippelde vlakken = plaatsingsgebied per factor. Rood = geen labels (centrum).
          Ctrl+D laadt <code>debug-sample.jari</code> met testdata.
        </p>
        {onLoadFixture && (
          <button type="button" className="cd-debug-panel__btn" onClick={onLoadFixture}>
            Herlaad test-.jari
          </button>
        )}
      </aside>
    </>
  );
}
